export default __webpack_public_path__ + "static/media/bg-min.716ebfec.jpeg";